import { Box, Button, Stack } from "@mui/material"

function StepButtons({
  backBtn,
  skipBtn,
  backBtnFun,
  isLastStep,
  nextBtnFun,
}) {

  return (
    <Stack
      mt={3}
      direction="row"
      justifyContent="space-between"
      spacing={1}
    >
      {backBtn &&
        <Button
          sx={{
            px: { md: 4 },
            fontSize: "18px",
            minWidth: "100px",
            borderRadius: "50px",
            justifyContent: "center"
          }}
          size="small"
          color="primary"
          variant="contained"
          onClick={backBtnFun || null}
        >Previous
        </Button>
      }
      <Box
        sx={{
          gap: 1,
          display: "flex",
          flexWrap: "nowrap",
          ml: { md: "auto !important" },
        }}
      >
        {skipBtn &&
          <Button
            sx={{
              px: { md: 4 },
              fontSize: "18px",
              minWidth: "100px",
              borderRadius: "50px",
              justifyContent: "center"
            }}
            size="small"
            color="primary"
            variant="outlined"
            onClick={nextBtnFun || null}
          >Skip
          </Button>
        }
        <Button
          sx={{
            px: { md: 4 },
            fontSize: "18px",
            minWidth: "100px",
            borderRadius: "50px",
            justifyContent: "center"
          }}
          size="small"
          type="submit"
          color="primary"
          variant="contained"
        >{isLastStep ? "Submit" : "Next"}
        </Button>
      </Box>
    </Stack>
  )
}

export default StepButtons